const LESSON_STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  FINISHED: 3,
  CANCELLED: 4,
  WEEKEND: 5
};

export default LESSON_STATUS;
